var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 69,
    viewBox: "0 0 61 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 4.3125C3.86777 4.3125 0 8.18027 0 12.9375V56.0625C0 60.8197 3.86777 64.6875 8.625 64.6875H51.75C56.5072 64.6875 60.375 60.8197 60.375 56.0625V12.9375C60.375 8.18027 56.5072 4.3125 51.75 4.3125H8.625ZM48.6639 15.6328L34.6752 31.616L51.1301 53.3672H38.2465L28.166 40.1736L16.6166 53.3672H10.2152L25.1742 36.2654L9.39316 15.6328H22.6002L31.7238 27.6943L42.2625 15.6328H48.6639ZM43.5697 49.5398L20.673 19.258H16.8592L40.0119 49.5398H43.5563H43.5697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.375,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterShare);
export default __webpack_public_path__ + "static/media/twitter-share.1c4ecb3ec117df5ffc3cab599aa504c0.svg";
export { ForwardRef as ReactComponent };